import React from 'react';

import { Container, Grid, makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => {
  return {
    bottomContainer: {},
    bottomDescription: {
      color: '#FFF',
      fontSize: '20px',
      fontWeight: '500',
      lineHeight: '25px',
      maxWidth: '553px',
      textAlign: 'center',
    },
    bottomDescriptionContainer: {
      backgroundColor: '#172B4D',
      clipPath: 'polygon(100% 0, 100% 74%, 50% 100%, 0% 74%, 0 0)',
      paddingBottom: '120px',
      paddingTop: '16px',
      textAlign: 'center',
    },
    container: {
      backgroundColor: '#172B4D',
      padding: '50px 0px 20px',
    },
    generalContainer: {
      padding: '0px 30px',
    },
    [theme.breakpoints.up('md')]: {
      bottomContainer: {},
      bottomDescriptionContainer: {
        clipPath: 'polygon(50% 100%, 0 0, 100% 0);',
        paddingBottom: '160px',
      },
      container: {
        padding: '69px 0px 48px',
      },
    },
  };
});

export default ({ children, description }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.container}>{children}</div>
      {description && (
        <div className={classes.bottomContainer}>
          <div className={classes.bottomDescriptionContainer}>
            <Container className={classes.generalContainer}>
              <Grid container justify="center">
                <Grid item>
                  <Typography variant="h3" className={classes.bottomDescription} style={{ marginBottom: '0px' }}>
                    {description}
                  </Typography>
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
      )}
    </>
  );
};
